'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DeviceRoutes;

var _devicesTpl = require('./devices.tpl.html');

var _devicesTpl2 = _interopRequireDefault(_devicesTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
function DeviceRoutes($stateProvider, types) {
    $stateProvider.state('home.devices', {
        url: '/devices',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
        views: {
            "content@home": {
                templateUrl: _devicesTpl2.default,
                controller: 'DeviceController',
                controllerAs: 'vm'
            }
        },
        data: {
            devicesType: 'tenant',
            searchEnabled: true,
            searchByEntitySubtype: true,
            searchEntityType: types.entityType.device,
            pageTitle: 'device.devices'
        },
        ncyBreadcrumb: {
            label: '{"icon": "devices_other", "label": "device.devices"}'
        }
    }).state('home.customers.devices', {
        url: '/:customerId/devices',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _devicesTpl2.default,
                controllerAs: 'vm',
                controller: 'DeviceController'
            }
        },
        data: {
            devicesType: 'customer',
            searchEnabled: true,
            searchByEntitySubtype: true,
            searchEntityType: types.entityType.device,
            pageTitle: 'customer.devices'
        },
        ncyBreadcrumb: {
            label: '{"icon": "devices_other", "label": "{{ vm.customerDevicesTitle }}", "translate": "false"}'
        }
    });
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/* eslint-disable import/no-unresolved, import/default */


// WEBPACK FOOTER //
// ./src/app/device/device.routes.js